import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {ApiService} from '../../services/api.service';
import {DEFAULT_TABLE_PAGE_SIZE_OPTIONS} from '../../shared/constants/pagination.constants';
import {VtePaginationComponent} from '../../shared/vte/vte-pagination/vte-pagination.component';

type ContactUsRequest = {
    id: number;
    name: string;
    email: string;
    message: string;
    created_at: string;
    status: string | null;
};

@Component({
    selector: 'app-contact-us-requests',
    imports: [CommonModule, FormsModule, VtePaginationComponent],
    templateUrl: './contact-us-requests.component.html',
    styleUrls: ['./contact-us-requests.component.css']
})
export class ContactUsRequestsComponent implements OnInit {
    readonly pageSizeOptions = DEFAULT_TABLE_PAGE_SIZE_OPTIONS;
    requests: ContactUsRequest[] = [];
    loading = false;

    recordsPerPage = 25;
    currentPage = 1;
    totalRecords = 0;
    totalPages = 1;
    nextPage: string | null = null;
    previousPage: string | null = null;

    constructor(private apiService: ApiService) {
    }

    ngOnInit(): void {
        this.fetchRequests();
    }

    fetchRequests(): void {
        this.loading = true;
        this.apiService.listContactUsRequests(this.currentPage, this.recordsPerPage).subscribe({
            next: (data: any) => {
                this.requests = data?.results ?? [];
                this.totalRecords = data?.count ?? 0;
                this.nextPage = data?.next ?? null;
                this.previousPage = data?.previous ?? null;
                this.totalPages = Math.max(1, Math.ceil(this.totalRecords / this.recordsPerPage));
                this.loading = false;
            },
            error: () => {
                this.requests = [];
                this.totalRecords = 0;
                this.totalPages = 1;
                this.loading = false;
            }
        });
    }

    refresh(): void {
        this.fetchRequests();
    }

    next(): void {
        if (!this.nextPage) {
            return;
        }
        this.currentPage++;
        this.fetchRequests();
    }

    previous(): void {
        if (!this.previousPage) {
            return;
        }
        this.currentPage--;
        this.fetchRequests();
    }

    selectPageSize(): void {
        this.currentPage = 1;
        this.fetchRequests();
    }

    onPageChange(page: number): void {
        this.currentPage = page;
        this.fetchRequests();
    }

    onPageSizeChange(pageSize: number): void {
        this.recordsPerPage = pageSize;
        this.currentPage = 1;
        this.fetchRequests();
    }
}
